// CN marketplace configurations related to ProductList scope.

// specificSearchResult imageResolution
export const IMAGE_RESOLUTION = 300;

// specificSearchResult pageSize
export const ASINS_QUANTITY_THRESHOLD_PER_PAGE = 10;

// specificSearchResult data sort
export const DATA_SORT = 'relevancerank';

export const TOP_CATEGORY_ID = 'n';
